// import optionTypesClient from '@/client/options/definition/option-types.client';

/*
|-------------------------------------------------------------------------------
| Your option mappings can be defined below (refer to src/options/definition/option-mappings.js for syntax)
| Uncomment the needed import above
| See the README in this folder, or the docsify documentation for more information
|-------------------------------------------------------------------------------
*/

export const baseAtomMappingClient = {
    layout: [],
    component: [],
    text: [],
    visibility: [],
    accessibility: [],
};


export const baseOrganismMappingClient = {
    layout: [],
    component: [],
    text: [],
    visibility: [],
    accessibility: [],
};
